define 'controller/ShowMoreProductsController', ['jquery', 'lib/kryptonite'], ($) ->
  class ShowMoreProductsController

    constructor: (@$el) ->
      self = @
      @$el.on 'click', (e) =>
        e.preventDefault()
        $button = @$el
        if($('.category').length > 0 && $button.length > 0)
          if($button.data('url').length > 0)
            url = $button.data('url')
            $button.data('url', '')

            if history.pushState?
              history.pushState(null, null, url)
            $.kryptonite
              url: url + '&more=1&ajax=true'
              method: 'GET'

    destroy: ->
      @$el.off()